// Application URL
export const APP_URL = 'http://iran-safar.com'
// Application API URL & PORT
// export const API_PORT = 5000
// export const API_URL = `http://api.iran-safar.com:${API_PORT}`
// Application Domain Title
export const DOMAIN_TITLE = 'ایران سفر'
//Ticket API URL & PORT
// export const TICKET_API_URL = 'http://iran-safar.com/v2'
export const API_URL = 'http://iran-safar.com/v2'

export const CHARTER_725_API_URL = 'http://api.charter725.ir/'